<template>
  <input
    v-if="fieldDefinition.type === 'string'"
    class="input"
    type="text"
    v-model.trim="fieldData.value"
    :class="classes"
    placeholder="String"
    :disabled="fieldData.loading || !fieldDefinition.editable || undefined"
  />
  <textarea
    v-else-if="fieldDefinition.type === 'text'"
    class="textarea"
    v-model.trim="fieldData.value"
    :class="classes"
    placeholder="Text"
    :disabled="fieldData.loading || !fieldDefinition.editable || undefined"
  ></textarea>
  <p
    class="help is-danger"
    v-for="(error, i) in [...localErrors, ...fieldData.errors]"
    :key="i"
  >
    {{ error }}
  </p>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { type FieldModel, type FieldProps, defineValidator } from '.'

type Constraint = { type: 'string' | 'text'; many: false }
const { fieldDefinition } = defineProps<FieldProps<Constraint>>()
const fieldData = defineModel<FieldModel<Constraint>>({ required: true })

const classes = computed(() => ({
  'is-danger': !fieldData.value.valid,
  'is-loading': fieldData.value.loading,
}))

const { localErrors } = defineValidator(fieldDefinition, fieldData.value)
</script>
